import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, Theme } from "../../types"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Theme>()

export function TableThemes({
  themes,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  themes: Theme[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!themes) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [themes, count])
  return (
    <Table
      data={themes}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Nome"
        name="name"
        sortable
        width="minmax(max-content, 1fr)"
        render={(theme) => (
          <Link to={`/themes/themes/${theme.id}`}>
            <LinkMagik className="text-dark">{theme.name}</LinkMagik>
          </Link>
        )}
        stickyLeft
        // TODO badge
      />


      <Table.Column
        title="Ordine"
        name="order"
        sortable
        width="minmax(max-content, 1fr)"
        render={(group) => {
          return group.order
        }}
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} temi
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
